import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookFormComponent } from './book-form.component';
import { InputModule } from 'src/app/shared/input/input.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'src/app/shared/button/button.module';
import { InputCanvasModule } from './components/input-canvas/input-canvas.module';
import { InputGroupModule } from './components/input-group/input-group.module';

@NgModule({
  declarations: [BookFormComponent],
  imports: [
    CommonModule,
    InputModule,
    ButtonModule,
    ReactiveFormsModule,
    TranslateModule,
    InputCanvasModule,
    InputGroupModule,
  ],
  exports: [BookFormComponent, InputCanvasModule, InputGroupModule],
})
export class BookFormModule {}
